module.exports = __webpack_public_path__ + "img/沈阳自有.c8c6be89.png";